import React, { PropTypes, Component } from 'react'

import './EditProfile.scss'
import ProfileInputControl from './components/ProfileInputControl'

class EditProfile extends Component {
  componentDidMount () {
    this.props.updateTitle('Editar Perfil')
  }

  render () {
    return (
      <div className='EditProfile'>
        <div className='EditProfile-contentCard'>
          <div className='EditProfile-cardTitle'>
            Datos de Contacto
          </div>
          <div className='EditProfile-cardBody'>

            <ProfileInputControl label='Nombre'>
              <div className='form-group'>
                <input type='text' name='first-name' id='first-name' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Apellido'>
              <div className='form-group'>
                <input type='text' name='last-name' id='last-name' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl
              label='Soy'
              help='Utilizamos estos datos para realizar estudios y nunca los compartimos con otros usuarios.'
              >
              <div className='form-group'>
                <select name='gender' id='gender' className='EditProfile-input form-control'>
                  <option value='hombre'>Hombre</option>
                  <option value='mujer'>Mujer</option>
                </select>
              </div>
            </ProfileInputControl>

            <ProfileInputControl
              label='Fecha de nacimiento'
              help='Utilizamos estos datos para realizar estudios y nunca los compartimos con otros usuarios.'
              >
              <div className='EditProfile-dob'>
                <div className='form-group'>
                  <select name='dobDay' id='dobDay' className='form-control'>
                    <option value='' selected>Día</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                    <option value='5'>5</option>
                    <option value='6'>6</option>
                    <option value='7'>7</option>
                    <option value='8'>8</option>
                    <option value='9'>9</option>
                    <option value='10'>10</option>
                    <option value='11'>11</option>
                    <option value='12'>12</option>
                    <option value='13'>13</option>
                    <option value='14'>14</option>
                    <option value='15'>15</option>
                    <option value='16'>16</option>
                    <option value='17'>17</option>
                    <option value='18'>18</option>
                    <option value='19'>19</option>
                    <option value='20'>20</option>
                    <option value='21'>21</option>
                    <option value='22'>22</option>
                    <option value='23'>23</option>
                    <option value='24'>24</option>
                    <option value='25'>25</option>
                    <option value='26'>26</option>
                    <option value='27'>27</option>
                    <option value='28'>28</option>
                    <option value='29'>29</option>
                    <option value='30'>30</option>
                    <option value='31'>31</option>
                  </select>
                </div>
                <div className='form-group'>
                  <select name='dobMonth' id='dobMonth' className='form-control'>
                    <option value='' selected>Mes</option>
                    <option value='0'>Enero</option>
                    <option value='1'>Febrero</option>
                    <option value='2'>Marzo</option>
                    <option value='3'>Abril</option>
                    <option value='4'>Mayo</option>
                    <option value='5'>Junio</option>
                    <option value='6'>Julio</option>
                    <option value='7'>Agosto</option>
                    <option value='8'>Septiembre</option>
                    <option value='9'>Octubre</option>
                    <option value='10'>Noviembre</option>
                    <option value='11'>Diciembre</option>
                  </select>
                </div>
                <div className='form-group'>
                  <select name='dobYear' id='dobYear' className='form-control'>
                    <option value='' selected>Año</option>
                    <option value='1917'>1917</option>
                    <option value='1918'>1918</option>
                    <option value='1919'>1919</option>
                    <option value='1920'>1920</option>
                    <option value='1921'>1921</option>
                    <option value='1922'>1922</option>
                    <option value='1923'>1923</option>
                    <option value='1924'>1924</option>
                    <option value='1925'>1925</option>
                    <option value='1926'>1926</option>
                    <option value='1927'>1927</option>
                    <option value='1928'>1928</option>
                    <option value='1929'>1929</option>
                    <option value='1930'>1930</option>
                    <option value='1931'>1931</option>
                    <option value='1932'>1932</option>
                    <option value='1933'>1933</option>
                    <option value='1934'>1934</option>
                    <option value='1935'>1935</option>
                    <option value='1936'>1936</option>
                    <option value='1937'>1937</option>
                    <option value='1938'>1938</option>
                    <option value='1939'>1939</option>
                    <option value='1940'>1940</option>
                    <option value='1941'>1941</option>
                    <option value='1942'>1942</option>
                    <option value='1943'>1943</option>
                    <option value='1944'>1944</option>
                    <option value='1945'>1945</option>
                    <option value='1946'>1946</option>
                    <option value='1947'>1947</option>
                    <option value='1948'>1948</option>
                    <option value='1949'>1949</option>
                    <option value='1950'>1950</option>
                    <option value='1951'>1951</option>
                    <option value='1952'>1952</option>
                    <option value='1953'>1953</option>
                    <option value='1954'>1954</option>
                    <option value='1955'>1955</option>
                    <option value='1956'>1956</option>
                    <option value='1957'>1957</option>
                    <option value='1958'>1958</option>
                    <option value='1959'>1959</option>
                    <option value='1960'>1960</option>
                    <option value='1961'>1961</option>
                    <option value='1962'>1962</option>
                    <option value='1963'>1963</option>
                    <option value='1964'>1964</option>
                    <option value='1965'>1965</option>
                    <option value='1966'>1966</option>
                    <option value='1967'>1967</option>
                    <option value='1968'>1968</option>
                    <option value='1969'>1969</option>
                    <option value='1970'>1970</option>
                    <option value='1971'>1971</option>
                    <option value='1972'>1972</option>
                    <option value='1973'>1973</option>
                    <option value='1974'>1974</option>
                    <option value='1975'>1975</option>
                    <option value='1976'>1976</option>
                    <option value='1977'>1977</option>
                    <option value='1978'>1978</option>
                    <option value='1979'>1979</option>
                    <option value='1980'>1980</option>
                    <option value='1981'>1981</option>
                    <option value='1982'>1982</option>
                    <option value='1983'>1983</option>
                    <option value='1984'>1984</option>
                    <option value='1985'>1985</option>
                    <option value='1986'>1986</option>
                    <option value='1987'>1987</option>
                    <option value='1988'>1988</option>
                    <option value='1989'>1989</option>
                    <option value='1990'>1990</option>
                    <option value='1991'>1991</option>
                    <option value='1992'>1992</option>
                    <option value='1993'>1993</option>
                    <option value='1994'>1994</option>
                    <option value='1995'>1995</option>
                    <option value='1996'>1996</option>
                    <option value='1997'>1997</option>
                    <option value='1998'>1998</option>
                    <option value='1999'>1999</option>
                    <option value='2000'>2000</option>
                    <option value='2001'>2001</option>
                    <option value='2002'>2002</option>
                    <option value='2003'>2003</option>
                    <option value='2004'>2004</option>
                    <option value='2005'>2005</option>
                    <option value='2006'>2006</option>
                    <option value='2007'>2007</option>
                    <option value='2008'>2008</option>
                    <option value='2009'>2009</option>
                    <option value='2010'>2010</option>
                    <option value='2011'>2011</option>
                    <option value='2012'>2012</option>
                    <option value='2013'>2013</option>
                    <option value='2014'>2014</option>
                    <option value='2015'>2015</option>
                    <option value='2016'>2016</option>
                  </select>
                </div>
              </div>
            </ProfileInputControl>

            <ProfileInputControl
              label='Telefono'
              help='Estos datos solo se compartirán cuando tengas una reserva confirmada con una aliada. Es el método que utilizamos para ponernos en contacto contigo.'
              >
              <div className='form-group'>
                <input type='text' name='phone' id='phone' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl
              label='Correo electrónico'
              help='No compartiremos tu dirección de correo electrónico personal con ningún usuario de la plataforma ni terceros.'
              >
              <div className='form-group'>
                <input type='email' name='email' id='email' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <div className='EditProfile-cardButton'>
              <button className='btn btn-lg btn-primary btn-block'>Guardar</button>
            </div>

          </div>
        </div>

        <div className='EditProfile-contentCard'>
          <div className='EditProfile-cardTitle'>
            Dirección
          </div>
          <div className='EditProfile-cardBody'>

            <ProfileInputControl label='Calle'>
              <div className='form-group'>
                <input type='text' name='street' id='street' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Número exterior'>
              <div className='form-group'>
                <input type='text' name='exteriorNumber' id='exteriorNumber' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Número interior'>
              <div className='form-group'>
                <input type='text' name='interiorNumber' id='interiorNumber' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Colonia'>
              <div className='form-group'>
                <input type='text' name='Neighborhood' id='Neighborhood' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Delegación'>
              <div className='form-group'>
                <input type='text' name='city' id='city' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl
              label='Estado'
              help='No compartiremos tu dirección con ninguna finalidad además de hacer que tus aliadas lleguen hasta tu domicilio.'
              >
              <div className='form-group'>
                <input type='text' name='state' id='state' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <p className='EditProfile-warning'><b>Por el momento, para realizar cambios en tu dirección es necesario que te comuniques con nosotros.</b></p>

            <div className='EditProfile-cardButton'>
              <button className='btn btn-lg btn-primary btn-block'>Solicitar cambio de dirección</button>
            </div>

          </div>
        </div>

        <div className='EditProfile-contentCard'>
          <div className='EditProfile-cardTitle'>
            Contraseña
          </div>
          <div className='EditProfile-cardBody'>

            <ProfileInputControl label='Contraseña actual'>
              <div className='form-group'>
                <input type='password' name='currentPassword' id='currentPassword' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Nueva contraseña'>
              <div className='form-group'>
                <input type='password' name='newPassword' id='newPassword' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <ProfileInputControl label='Verificar contraseña'>
              <div className='form-group'>
                <input type='password' name='confirmPassword' id='confirmPassword' className='EditProfile-input form-control' />
              </div>
            </ProfileInputControl>

            <div className='EditProfile-cardButton'>
              <button className='btn btn-lg btn-primary btn-block'>Guardar nueva contraseña</button>
            </div>

          </div>
        </div>

      </div>
    )
  }
}

EditProfile.displayName = 'EditProfile'
EditProfile.propTypes = {}
EditProfile.defaultProps = {}

export default EditProfile



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/EditProfile/EditProfile.js